import { REGIONS, SORT_OPTIONS, YEARS, type SortKey } from "@/lib/videos";
import type { Region } from "@/types/video";

interface FilterPanelProps {
  region: Region | "不限";
  year: number | "不限";
  sort: SortKey;
  onRegionChange: (value: Region | "不限") => void;
  onYearChange: (value: number | "不限") => void;
  onSortChange: (value: SortKey) => void;
  onReset: () => void;
}

export default function FilterPanel({
  region,
  year,
  sort,
  onRegionChange,
  onYearChange,
  onSortChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="mb-3 flex items-center gap-1.5 font-heading text-sm font-semibold text-foreground-900">
          <i className="ri-map-pin-line text-primary-500"></i>
          地区
        </h3>
        <div className="flex flex-wrap gap-2">
          {REGIONS.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => onRegionChange(item)}
              className={`rounded-full px-3.5 py-1.5 text-sm transition-colors whitespace-nowrap ${
                region === item
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="mb-3 flex items-center gap-1.5 font-heading text-sm font-semibold text-foreground-900">
          <i className="ri-calendar-line text-primary-500"></i>
          年份
        </h3>
        <select
          value={year}
          onChange={(event) =>
            onYearChange(event.target.value === "不限" ? "不限" : Number(event.target.value))
          }
          className="h-10 w-full rounded-md border border-background-200/80 bg-background-50 px-3 text-sm text-foreground-900 outline-none focus:border-primary-400"
        >
          <option value="不限">不限</option>
          {YEARS.map((item) => (
            <option key={item} value={item}>
              {item} 年
            </option>
          ))}
        </select>
      </div>

      <div>
        <h3 className="mb-3 flex items-center gap-1.5 font-heading text-sm font-semibold text-foreground-900">
          <i className="ri-sort-desc text-primary-500"></i>
          排序方式
        </h3>
        <div className="flex flex-col gap-2">
          {SORT_OPTIONS.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => onSortChange(option.key)}
              className={`flex items-center gap-2 rounded-md px-3.5 py-2 text-left text-sm transition-colors ${
                sort === option.key
                  ? "bg-primary-50 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <i
                className={
                  sort === option.key ? "ri-radio-button-line" : "ri-checkbox-blank-circle-line"
                }
              ></i>
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onReset}
        className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
      >
        <i className="ri-refresh-line"></i>
        重置筛选
      </button>
    </div>
  );
}